import { makeExecutableSchema } from '@graphql-tools/schema';

import { getList, getOne } from '@apis/api';

/** 타입 정의 */
const typeDefs = `
    type Portfolio {
      id: Int!
      mappingId: String
      mappingCompany: InnoforestCompany
      investSummary: InvestSummary
      investInfos: [InvestInfo]
      assigneeInfos: [Assignee]
      growth: Growth
    }
    
    type InnoforestCompany {
      mappingId: String
      name: String
      serviceName: String
      ceo: String
      capital: Float
      bizNo: String
      establishmentDate: String
    }

    type InvestSummary {
      lastInvestDate: String
      totalInvestmentCount: Int
      shareholdingCount: Float
      totalInvestmentAmount: Float
      corporateValue: Float
      lastCorporateValue: Float
      accumulatedIssuanceQuantity: Float
      equityValue: Float
    }

    type InvestInfo {
      id: Int!
      faceValue: Int
      totalShares: Float
      investDate: String
      investmentUnitPrice: Float
      shareholding: Float
      investmentAmount: Float
      stockType: String
    }

    type Assignee {
      id: Int!
      email: String
    }

    type Growth {
      traffic: [GrowthType]
      sales: [GrowthType]
      employee: [GrowthType]
    }

    type GrowthType {
      referenceMonth: String
      value: Float
    }

    type PaginationInfo {
        pageNo: Int
        pageSize: Int
        totalCount: Int
        totalPage: Int
    }

    type PortfolioListConnection {
        pagination: PaginationInfo!
        portfolioList: [Portfolio]
    }

    type Query {
        portfolioList(pageNo: Int, pageSize: Int, groupId: String): PortfolioListConnection
        reportPortfolioList(pageNo: Int, pageSize: Int, groupId: String): PortfolioListConnection
        portfolioDetail(groupId: String, portfolioId: String): Portfolio
    }
`;

/** 리졸버 정의 */
const resolvers = {
  Query: {
    /** 조합 관리 > 상세 > 투자 정보 */
    portfolioList(_: any, args: any) {
      return getList(
        `/fund/${args.groupId}/portfolio?page=${args.pageNo}&size=${args.pageSize}`,
        ''
      ).then((res) => {
        const portfolioListConnection = {
          pagination: _schemaUtils.createPaginationInfoFromResponse(res),
          portfolioList: res.content,
        };

        return portfolioListConnection;
      });
    },
    /** 조합 관리 > 상세 > 포트폴리오 상세 > 기업 상세정보 */
    portfolioDetail(_: any, args: any) {
      return getOne(`/fund/${args.groupId}/portfolio/${args.portfolioId}`, '');
    },
    /** 기업보고자료 관리 > 등록 > 기업목록 */
    reportPortfolioList(_: any, args: any) {
      return getList(
        `/fund/${args.groupId}/portfolio?page=${args.pageNo}&size=${args.pageSize}`,
        ''
      ).then((res) => {
        const portfolioListConnection = {
          pagination: _schemaUtils.createPaginationInfoFromResponse(res),
          portfolioList: res.content,
        };

        return portfolioListConnection;
      });
    },
  },
  Portfolio: {
    mappingCompany(parent: any) {
      return getList(
        `/data-ref/corporation?mappingId=${parent.mappingId}`,
        ''
      ).then((res) => {
        return res?.content?.[0];
      });
    },
    growth(parent: any) {
      return getList(
        `/data-ref/monthly-growth?mappingId=${parent.mappingId}`,
        ''
      );
    },
  },
};

/** 스키마 유틸 */
const _schemaUtils = {
  /** 페이지네이션 */
  createPaginationInfoFromResponse: (response: any) => {
    const paginationInfo = {
      pageNo: response?.page ?? 0,
      pageSize: response?.size ?? 0,
      totalCount: response?.totalCount ?? 0,
      totalPage: response?.totalPage ?? 0,
    };

    return paginationInfo;
  },
};

/** 스키마 생성 */
const schema = makeExecutableSchema({ typeDefs, resolvers });

export default schema;
